import { gql } from "@apollo/client";

export const GET_ENVIO_INDICACIONES = gql`
  query GetEnvioIndicacionActiva(
              $idOrdenPedido: Int!, 
              $idEvaluacion: Int!,
              $fechaDesde: CustomDateTime!,
              $fechaHasta: CustomDateTime!) {
    envioIndicacionActiva(
          idOrdenPedido: $idOrdenPedido, 
          idEvaluacion: $idEvaluacion,
          fechaDesde: $fechaDesde,
          fechaHasta: $fechaHasta
          ) {      
      idIndicacion,
      fechaDesde,
      fechaHasta,
      usuario,
      fechaAlta,
      insumos {
        idIndicacion,
        idInsumoN,
        insumo,
        cantidad,
        unidad
      }      
    }
  }
`;